const configurators = [...document.querySelectorAll('.product-configurator')]

if (configurators.length) {
	configurators.forEach((instance) => {
		// Sets handlers for steps navigation
    	const items = [...instance.querySelectorAll('.step')];

    	items.forEach((item) => {
      		const head = item.querySelector('.step-header');
        	const body = item.querySelector('.step-body');

			head.querySelector('.badge').innerText = item.querySelectorAll('.property-options li').length;

			if (items.length > 1) {
				head.addEventListener('click', () => {
					if (item.classList.contains('--active')) {
						// gsap.to(body, {
						// 	height: 0,
						// 	onComplete: () => {
						// 		item.classList.remove('--active', '--default-open');
						// 	}
						// });
					}
					else {
						instance.querySelectorAll('.step.--active').forEach((elem) => {
							gsap.to(elem.querySelector('.step-body'), {
								height: 0,
								onComplete: () => {
									elem.classList.remove('--active', '--default-open');
									elem.querySelector('.step-header').classList.remove('--cursor-default');
								}
							});
						  });
	
						gsap.to(body, { height: 'auto' });
						item.classList.add('--active');
						head.classList.add('--cursor-default');
					}
				});
			}
			else {
				head.classList.add('--cursor-default');
			}
    	});

		// Sets handler per properties selectors
		const props = [...instance.querySelectorAll('.property-options')];

		props.forEach((optGroup) => {
			const options = optGroup.querySelectorAll('li');

			options.forEach((opt) => {
				opt.style.backgroundImage = 'url(' + opt.dataset.sample + ')';

				opt.addEventListener('click', (e) => {
					if (!e.target.closest('li').classList.contains('--selected')) {
						e.target.closest('ul').querySelector('.--selected').classList.remove('--selected');
						e.target.closest('li').classList.add('--selected');

						// Update preview
						updateConfiguratorPreview(instance);
					}
				});
			});
		});
  	});
}

//var instance = null;

function updateConfiguratorPreview(configuratorInstance) {
	//instance = configuratorInstance;
	
	let property_1 = configuratorInstance.querySelector('[data-property="property-1"] li.--selected');
	let property_2 = configuratorInstance.querySelector('[data-property="property-2"] li.--selected');
	let property_3 = configuratorInstance.querySelector('[data-property="property-3"] li.--selected');

	let combo_id = property_1.dataset.value + "_" + (property_2 != null ? property_2.dataset.value : "0") + "_" + (property_3 != null ? property_3.dataset.value : "0");
	let prevObj = previews[configuratorInstance.getAttribute('id')].find((element) =>  element.id == combo_id);

	if (prevObj) {
		configuratorInstance.querySelector('.configurator-preview').setAttribute('src', prevObj.asset);
	}
	else {
		configuratorInstance.querySelector('.configurator-preview').setAttribute('src', '/wp-content/imports/configurators/combo-unavailable.jpg');
	}

	getCurrentConfiguration(configuratorInstance);
}

function getCurrentConfiguration(configuratorInstance) {
	steps[configuratorInstance.getAttribute('id')].forEach((stepObj) => {
		let stepOptions = stepObj.options;

		stepOptions.forEach((opt) => {
			let propertyObj = configuratorInstance.querySelector('[data-property="' + opt + '"] li.--selected');

			console.log({
				step: stepObj.label[lang],
				property: opt,
				optionId: propertyObj.dataset.value,
				label: propertyObj.dataset.label
			});
		});
	});
}
